import Vuex from 'vuex'
import home from "@/store/modules/home";
import pay from "@/store/modules/pay";
import createPersistedState from 'vuex-persistedstate'


const store = new Vuex.Store({
  modules: {
    home,
    pay
  },
  plugins: [
    createPersistedState({
      key: 'pay_vue_store',
      paths: ['pay.appId', 'pay.paymentType'] // 只持久化这些字段
    })
  ]
});

export default store
